"use client"

import { Guard } from "@/components/utils"

export default function AuthorizedLayout({ children }: { children: React.ReactNode }) {
  return <Guard>{children}</Guard>
}
